import CONSTANTS from '@/constants'

const { NETWORKING, CYBER_SECURITY, CLOUD } = CONSTANTS.SKILL_DIVE_LEARNING_AREAS

export const skillDiveHydratation = skillDiveCollection => {
  return skillDiveCollection.forEach(addOn => {
    addOn.product_type = 'addon'
    switch (addOn.merchant_id) {
      case NETWORKING:
        addOn.label = 'Networking'
        break
      case CYBER_SECURITY:
        addOn.label = 'Cyber Security'
        break
      case CLOUD:
        addOn.label = 'Cloud'
        break
    }
  })
}
